module.exports = __webpack_public_path__ + "resources/img/img_zenius_logmanager_1_m_en.708c2d5ba795965202ad481fc1c36e71.png";